import { NeedModel } from "../../../../models";

export const sumQuantity = (needs: NeedModel[]): number => {
  if (!needs?.length) return 0;
  return needs.reduce(
    (total: number, need: NeedModel) => total + need?.quantity,
    0,
  );
};
